import React, { useEffect, useState } from "react";
import "./navbar.scss";
import { Badge, Divider, MenuItem, TextField } from "@mui/material";
import brandStore from "../../store/brandStore";
import { Link, useLocation, useRoutes } from "react-router-dom";
import categoryStore from "../../store/categoryStore";

// Icon
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import searchTagStore from "../../store/searchTagStore";
import filterStore from "../../store/filterStore";
import authStore from "../../store/authStore";
import cartStore from "../../store/cartStore";

import text_logo from "../../assets/logo-text.png";

import MyBrandSVG from "../SVG/MyBrandSVG";

const Navbar = ({ isOpenSidebar, setIsOpenSidebar, navbarPageClass }) => {
  const location = useLocation();
  const BrandStore = brandStore();
  const AuthStore = authStore();
  const CartStore = cartStore();
  const CategoryStore = categoryStore();
  const SearchTagStore = searchTagStore();
  const FilterStore = filterStore();
  const [searchOptions, setSearchOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [searchNoFound, setSearchNoFound] = useState(false);
  const [loginTo, setLoginTo] = useState();

  const [scroll100vh, setScroll100vh] = useState(false);

  useEffect(() => {
    if (search) {
      if (search.length >= 2) {
        if (SearchTagStore.searchTags && SearchTagStore.searchTags.length) {
          const options = SearchTagStore.searchTags.filter((item) => {
            return item.tag.toLowerCase().includes(search.toLowerCase());
          });
          if (options.length) {
            setSearchNoFound(false);
            setSearchOptions(
              options.slice(0, 8).sort((a, b) => {
                return a.tag.localeCompare(b.tag);
              }),
            );
          } else {
            setSearchNoFound(true);
            setSearchOptions(options);
          }
        }
      } else {
        setSearchNoFound(false);
        setSearchOptions([]);
      }
    } else {
      setSearchNoFound(false);
      setSearchOptions([]);
    }
  }, [SearchTagStore.searchTags, search]);

  useEffect(() => {
    if (AuthStore.isLogged === true) {
      setLoginTo("/user/manage-account");
    } else {
      setLoginTo("/sign-in");
    }
  }, [AuthStore.isLogged]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // How far the user has scrolled
      // const viewportHeight = window.innerHeight * 0.9 * 2; // 200vh
      const viewportHeight = window.innerHeight * 0.9; // 100vh

      if (scrollY >= viewportHeight) {
        setScroll100vh(true);
      } else {
        setScroll100vh(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      // className={`navbar ${
      //   location.pathname === "/" && !scroll100vh ? "no-color-change" : ""
      // } ${navbarPageClass}`}
      className={`navbar ${navbarPageClass}`}
    >
      <div className="leftSide">
        <div className="menuMobile">
          <MenuIcon
            onClick={() => setIsOpenSidebar(!isOpenSidebar)}
            className="icon"
          />
        </div>
      </div>
      <div className="center">
        <Link className="link svg" to="/">
          <MyBrandSVG className="brand-logo-svg" />
          {/* <img src={text_logo} alt="" className="brand-logo-text" /> */}
        </Link>
      </div>
      <div className="rightSide">
        {AuthStore.isLogged && (
          <div className="wishlist item">
            <Link to="wishlist" className="link">
              <FavoriteBorderOutlinedIcon className="icon" />
            </Link>
          </div>
        )}
        <div className="cart item">
          <div title={<p>Cart</p>} className="cartIcon">
            <Link to="/checkout" className="link">
              <Badge
                badgeContent={
                  CartStore.cartProduct ? CartStore.cartProduct.length : 0
                }
                overlap="circular"
                color="warning"
              >
                <ShoppingBagOutlinedIcon className="icon" />
              </Badge>
            </Link>
          </div>

          <p>
            <Link to="/checkout" className="link">
              Cart{" "}
              <span>
                ({CartStore.cartProduct ? CartStore.cartProduct.length : 0})
              </span>
            </Link>
          </p>
        </div>
        <div className="login item">
          <Link to={loginTo} className="link">
            <PersonOutlineOutlinedIcon className="icon" />
            {AuthStore.isLogged ? (
              <p>{AuthStore.myUser && AuthStore.myUser.firstName}</p>
            ) : (
              <p>Login</p>
            )}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
